import { type FC } from "react";

import { Check, Loader2 } from "lucide-react";

import { cn } from "@/shared/lib/utils";

interface ProcessingChecklistProps {
  items: readonly string[];
  activeIndex: number;
  isDone: boolean;
}

export const ProcessingChecklist: FC<ProcessingChecklistProps> = ({
  items,
  activeIndex,
  isDone,
}) => {
  return (
    <div className="mt-6 flex flex-col gap-3 text-left">
      {items.map((label, i) => {
        const isCompleted = i < activeIndex || isDone;
        const isActive = i === activeIndex && !isDone;
        const isPending = i > activeIndex && !isDone;

        return (
          <div
            key={label}
            className={cn(
              "flex items-center gap-3 transition-all duration-500",
              i <= activeIndex || isDone ? "translate-y-0 opacity-100" : "translate-y-2 opacity-0",
            )}
          >
            <div className="flex h-5 w-5 shrink-0 items-center justify-center">
              {isCompleted ? (
                <div className="flex h-5 w-5 items-center justify-center rounded-full bg-brand">
                  <Check className="h-3 w-3 text-white" strokeWidth={3} />
                </div>
              ) : isActive ? (
                <Loader2 className="h-5 w-5 animate-spin text-brand" />
              ) : (
                <div className="h-5 w-5 rounded-full border-2 border-primary" />
              )}
            </div>
            <p
              className={cn(
                "text-sm transition-colors duration-300",
                isPending ? "text-tertiary" : "text-primary",
              )}
            >
              {label}
            </p>
          </div>
        );
      })}
    </div>
  );
};
